import { useLocation } from "react-router-dom";

// One home for the Airplane Mode Games store identities and the
// campaign-tagged link building shared by the family page and the
// /get pages. server.js's smart-link 302s mirror these identities —
// keep both in sync when a game ships or gains a store listing.
export const APPLE_PROVIDER_TOKEN = "328659";

// appleId or packageName set to null = not on that store yet: badges
// and phone redirects for that store simply drop out.
export const GAMES = {
  poker: {
    name: "Airplane Mode Poker",
    appleId: "6791247916",
    packageName: "de.testco.airplanemode.poker",
  },
  "liars-dice": {
    name: "Airplane Mode Liar's Dice",
    appleId: "6797578260",
    packageName: "de.testco.airplanemode.liarsdice",
  },
  "board-games": {
    name: "Airplane Mode Classic Board Games",
    appleId: "6812980922",
    packageName: "de.testco.airplanemode.boardgames.classic",
  },
};

// Ads and posts land pages with ?c=<campaign>; store links pass it
// through so installs attribute in each store's console (App Analytics
// ct= / Play install referrer) — no pixels on the site itself.
export function useCampaign() {
  const params = new URLSearchParams(useLocation().search);
  return (params.get("c") || "").replace(/[^\w-]/g, "");
}

export function playHref(packageName, campaign) {
  const base = `https://play.google.com/store/apps/details?id=${packageName}`;
  if (!campaign) return base;
  const referrer = encodeURIComponent(
    `utm_source=testco&utm_medium=web&utm_campaign=${campaign}`
  );
  return `${base}&referrer=${referrer}`;
}

export function appStoreHref(appleId, campaign) {
  const base = `https://apps.apple.com/app/id${appleId}`;
  if (!campaign) return base;
  return `${base}?pt=${APPLE_PROVIDER_TOKEN}&ct=${campaign}&mt=8`;
}
